import { useState } from "react";
import { offseasonimgs } from "../data/galleryimgdata";


const Offseason = () => {
     const [selectedImage, setSelectedImage] = useState(null);
     const [currentIndex, setCurrentIndex] = useState(0);

     const openImage = (index) => {
          setCurrentIndex(index);
          setSelectedImage(offseasonimgs[index].image);
     };

     const closeImage = () => {
          setSelectedImage(null);
     };

     const prevImage = () => {
          const newIndex = (currentIndex - 1 + offseasonimgs.length) % offseasonimgs.length;
          setCurrentIndex(newIndex);
          setSelectedImage(offseasonimgs[newIndex].image);
     };

     const nextImage = () => {
          const newIndex = (currentIndex + 1) % offseasonimgs.length;
          setCurrentIndex(newIndex);
          setSelectedImage(offseasonimgs[newIndex].image);
     };

     return (
          <>
               <h1>The Offseason</h1>
               <div className="gallery-images-container">
                    {offseasonimgs.map((Offseason, index) => (
                         <img
                              loading="lazy"
                              alt="afrostalgia"
                              src={Offseason.image}
                              key={Offseason.id}
                              onClick={() => openImage(index)}
                              style={{ cursor: "pointer" }}
                         />
                    ))}
               </div>

               {selectedImage && (
                    <div className="modal">
                         <span className="close" onClick={closeImage}>&times;</span>
                         <button className="prev" onClick={prevImage}>&#10094;</button>
                         <img src={selectedImage} alt="Selected" className="modal-content" />
                         <button className="next" onClick={nextImage}>&#10095;</button>
                    </div>
               )}
          </>
     );
};

export default Offseason;

